<template>
  <div id="buyer_center">
    <div class="buyer-title">
      <div class="title-left">
        <i class="title-icon el-icon-document-checked"></i>
        商品详情
      </div>
      <div class="title-right">
        <router-link :to="{ name: 'SellerSincerity' }">返回</router-link>
      </div>
    </div>
    <div class="buyer_main">
      <div class="info-section">
        <div class="buyer_main_title">服务信息</div>
        <el-table :data="tableData" border class="detail-table">
          <el-table-column
            v-for="item in tableColumn"
            :label="item.label"
            :min-width="item.minWidth"
            :prop="item.prop"
            align="center"
            :class-name="
              ['serve_amount_total', 'user_coupon_amount', 'serve_amount'].includes(item.prop)
                ? 'amount-cell'
                : item.prop === 'status'
                ? 'status-cell'
                : ''
            "
            :key="item.id"
          >
            <template slot-scope="scope">
              <template v-if="item.prop === 'status'">
                {{
                  scope.row.status == 1
                    ? "待付款"
                    : scope.row.status == 2
                    ? "已完成"
                    : scope.row.status == 3
                    ? "已取消"
                    : scope.row.status == 4
                    ? "退款中"
                    : "已退款"
                }}
              </template>
              <div v-else-if="item.prop === 'add_time'">
                {{ $formatDate(scope.row.add_time) }}
              </div>
              <template v-else>{{ scope.row[item.prop] }}</template>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="info-section">
        <div class="buyer_main_title">付款信息</div>
        <el-table :data="payData" border class="detail-table">
          <el-table-column
            v-for="item in payColumn"
            :label="item.label"
            :prop="item.prop"
            :min-width="item.minWidth"
            align="center"
            :class-name="
              item.prop === 'amount'
                ? 'amount-cell'
                : item.prop === 'inv_status_for_user'
                ? 'status-cell'
                : ''
            "
            :key="item.id"
          >
            <template slot-scope="scope">
              <div v-if="item.prop === 'inv_status_for_user'">付款成功</div>
              <!-- <div v-else-if="item.prop === 'add_time'">
                {{ $formatDate(scope.row.add_time) }}
              </div> -->
              <span v-else>{{ scope.row[item.prop] }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="info-section">
        <div class="buyer_main_title">优惠券信息</div>
        <el-table :data="coupon_info" border class="detail-table">
          <el-table-column label="优惠券类型" prop="coupon_type" align="center">
          </el-table-column>
          <el-table-column label="优惠券名称" prop="coupon_name" align="center">
          </el-table-column>
          <el-table-column label="使用门槛" prop="threshold" align="center">
          </el-table-column>
          <el-table-column label="优惠金额" prop="amount" align="center" class-name="amount-cell">
          </el-table-column>
        </el-table>
      </div>

      <div class="info-section">
        <div class="buyer_main_title">退款信息</div>
        <el-table :data="refundData" border class="detail-table">
          <el-table-column
            v-for="item in refundColumn"
            :label="item.label"
            :prop="item.prop"
            :min-width="item.minWidth"
            align="center"
            :class-name="
              item.prop === 'refund_amount'
                ? 'amount-cell'
                : item.prop === 'status'
                ? 'status-cell'
                : ''
            "
            :key="item.id"
          >
            <template slot-scope="scope">
              <div v-if="item.prop === 'status'">
                {{
                  scope.row.status == 1
                    ? "待退款"
                    : scope.row.status == 2
                    ? "退款中"
                    : scope.row.status == 3
                    ? "已退款"
                    : "退款失败"
                }}
              </div>
              <!-- <div v-else-if="item.prop === 'add_time'">
                {{ $formatDate(scope.row.add_time) }}
              </div> -->
              <span v-else>{{ scope.row[item.prop] }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
import { apiServeInfo } from "@/request/API";

export default {
  name: "SellerSincerityDetail",
  props: {},
  components: {},
  data() {
    return {
      id: "",
      tableData: [],
      tableColumn: [
        { label: "服务名称", prop: "serve_name", minWidth: 120 },
        { label: "服务金额", prop: "serve_amount_total" },
        { label: "诚心卖优惠券", prop: "user_coupon_amount" },
        { label: "订单应付金额", prop: "serve_amount" },
        { label: "服务状态", prop: "status" },
        { label: "商品编号", prop: "unique_no" },
        { label: "下单时间", prop: "add_time" },
      ],
      payData: [],
      payColumn: [
        { label: "订单编号", prop: "serve_order_no", minWidth: 100 },
        { label: "付款编号", prop: "payment_no", minWidth: 100 },
        { label: "付款金额", prop: "amount" },
        { label: "付款状态", prop: "inv_status_for_user" },
        { label: "付款时间", prop: "create_time" },
      ],
      coupon_info: [],
      refundData: [],
      refundColumn: [
        { label: "退款编号", prop: "refund_no" },
        { label: "退款金额", prop: "refund_amount" },
        { label: "退款状态", prop: "status" },
        { label: "退款时间", prop: "refund_time" },
        { label: "退款原因", prop: "reason" },
      ],
    };
  },
  created() {
    this.id = this.$route.query.id;
    apiServeInfo({
      id: this.id,
    }).then((res) => {
      this.tableData = [{ ...res.data }].map((v) => {
        v.serve_amount_total = "10.00";
        return v;
      });
      this.payData = res.data.payInvoice;
      this.coupon_info = res.data.coupon_info.map((v) => {
        switch (v.coupon_type) {
          case 1:
            v.coupon_type = "商品优惠券";
            break;
          case 2:
            v.coupon_type = "包赔优惠券";
            break;
          case 3:
            v.coupon_type = "诚心卖优惠券";
            break;
          default:
            break;
        }
        v.threshold = `满${v.threshold}元使用`;
        return v;
      });
      this.refundData = res.data.refundInvoice;
    });
  },
  methods: {},
  mounted() {},
  watch: {},
  computed: {},
};
</script>
<style lang='less' scoped>
#buyer_center {
  display: flex;
  flex-direction: column;
  min-height: 100%;
  background: transparent;
  color: var(--text-main, #111827);

  .buyer-title {
    min-height: 72px;
    background: var(--bg-dark, #1A1D24);
    padding: 0 28px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #fff;
    font-size: 20px;
    font-family: PingFang SC, PingFang SC-Medium;
    font-weight: 500;

    .title-left {
      display: flex;
      justify-content: flex-start;
      align-items: center;

      .title-icon {
        width: 34px;
        height: 34px;
        margin: 0 12px 0 0;
        border-radius: 4px;
        background: rgba(255, 255, 255, .16);
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 18px;
      }
    }

    .title-right {
      a {
        display: flex;
        align-items: center;
        height: 34px;
        padding: 0 14px;
        border: 1px solid rgba(255, 255, 255, .38);
        border-radius: 3px;
        font-size: 14px;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: 500;
        color: #ffffff;
        line-height: 32px;
        transition: all .2s ease;
      }

      a:hover {
        background: rgba(255, 255, 255, .14);
        border-color: rgba(255, 255, 255, .68);
      }
    }
  }

  .buyer_main {
    padding: 22px 28px 28px;
    background: var(--bg-card, #FFFFFF);

    .info-section {
      padding: 18px 20px 20px;
      margin: 0 0 18px;
      border: 1px solid var(--border-soft, #E8E4DE);
      border-radius: 4px;
      background: var(--bg-card, #FFFFFF);
      box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));
      overflow: hidden;

      &:last-child {
        margin-bottom: 0;
      }
    }

    .buyer_main_title {
      font-size: 18px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: var(--text-main, #111827);
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 18px;

      &::before {
        content: "";
        display: inline-block;
        width: 4px;
        height: 18px;
        background: var(--primary, #FF5A1F);
        border-radius: 4px;
        margin-right: 12px;
      }
    }

    .shop_info {
      margin-top: 0;
    }

    .detail-table {
      min-height: 88px;
      border-color: var(--border-soft, #E8E4DE);
      border-radius: 4px;
      overflow: hidden;

      /deep/ &::before,
      /deep/ &::after {
        background-color: var(--border-soft, #E8E4DE);
      }

      /deep/ th {
        height: 48px;
        background: var(--bg-tag, #F7F5F2);
        border-color: var(--border-soft, #E8E4DE);
        font-size: 14px;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: 500 !important;
        color: var(--text-secondary, #5A5F6B);
      }

      /deep/ td {
        height: 54px;
        border-color: var(--border-soft, #E8E4DE);
        font-size: 14px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: var(--text-main, #111827);
      }

      /deep/ .el-table__body tr:hover > td {
        background: var(--bg-tag, #F0EDE8);
      }

      /deep/ .el-table__empty-block {
        min-height: 88px;
      }

      /deep/ .el-table__empty-text {
        color: var(--text-muted, #9AA0AC);
      }

      /deep/ .el-table__body td.amount-cell {
        color: var(--primary, #FF7A1A);
        font-weight: 500;
      }

      /deep/ .el-table__body td.status-cell .cell {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        min-width: 68px;
        height: 28px;
        padding: 0 12px;
        border: 1px solid rgba(26, 29, 36, .12);
        border-radius: 4px;
        background: var(--bg-tag, #F0EDE8);
        color: var(--text-main, #1A1D24);
        font-size: 13px;
        line-height: 26px;
      }
    }

    /deep/th {
      font-weight: 500 !important;
    }
  }

  .no-border-left {
    border-left: none;
  }
}
</style>
